/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CreateApplicationErrorDto = {
  code: string;
  field?: string;
  message: string;
  errorClass: CreateApplicationErrorDto.errorClass;
  displayMessage?: string;
};
export namespace CreateApplicationErrorDto {
  export enum errorClass {
    INPUT_ERROR = 'INPUT_ERROR',
    TECHNICAL = 'TECHNICAL',
  }
}
